export default {
  institution: {
    name: 'İstanbul Teknik Üniversitesi',
    shortName: 'İTÜ',
    type: 'Devlet Üniversitesi',
    foundationYear: 1773,
    address: 'Ayazağa Kampüsü, Maslak 34469 Sarıyer-İstanbul',
    phone: '+90 (212) 285 29 10',
    email: 'iletisim@itu.edu.tr'
  },
  publications: {
    pageTitle: 'Yayınlar',
    pageDescription: 'Akademik yayın performansı ve istatistikler',
    totalPublications: {
      title: 'Toplam Makale',
      currentYear: 'Toplam Makale (2024)',
      lastFiveYears: 'Toplam Makale (Son Beş Yıl)'
    },
    metrics: {
      publicationsPerFaculty: 'Öğretim Üyesi Başına Düşen Yayın',
      citationsPerFaculty: 'Öğretim Üyesi Başına Düşen Atıf',
      q1PublicationsPerFaculty: 'Öğretim Üyesi Başına Düşen Q1 Yayın',
      totalPublications: 'Toplam Yayın',
      totalCitations: 'Toplam Atıf',
      totalQ1Publications: 'Toplam Q1 Yayın'
    },
    charts: {
      qDistribution: 'Q1-Q2-Q3-Q4 DAĞILIMI',
      yearlyTrend: 'Yıllık Trend',
      q1q2Percentage: 'Q1 + Q2 YÜZDESİ',
      publicationsPerFacultyByFaculty: 'Fakülte Bazında Öğretim Üyesi Başına Makale + Review Sayısı',
      publicationsPerFacultyByInstitute: 'Enstitü Bazında Öğretim Üyesi Başına Makale + Review Sayısı'
    },
    filters: {
      year: 'Yıl',
      index: 'İndeks',
      qCategory: 'Q Kategorisi',
      department: 'Bölüm',
      publicationType: 'Yayın Türü',
      searchPlaceholder: 'Yayın/Yazar/Anahtar Kelime Ara...'
    },
    summary: {
      facultyCount: 'Öğretim Üyesi Sayısı',
      articleCount: 'Makale ve Review Sayısı',
      q1q2PerFaculty: 'Öğretim Üyesi Başına Q1 + Q2',
      mrPerFaculty: 'Öğretim Üyesi Başına M-R Sayısı',
      q1PerFaculty: 'Öğretim Üyesi Başına Q1',
      q2PerFaculty: 'Öğretim Üyesi Başına Q2',
      q1Count: 'Q1',
      q2Count: 'Q2',
      q1q2Count: 'Q1 + Q2',
      q1Percentage: 'Q1 Yüzdesi',
      q2Percentage: 'Q2 Yüzdesi',
      q1q2Percentage: 'Q1 + Q2 Yüzdesi'
    },
    buttons: {
      fullText: 'Tam Metin',
      details: 'Detaylar'
    }
  },
  common: {
    search: 'Ara...',
    notifications: 'Bildirimler',
    settings: 'Ayarlar',
    darkTheme: 'Karanlık Tema',
    lightTheme: 'Aydınlık Tema',
    profile: 'Profil',
    logout: 'Çıkış Yap'
  },
  navigation: {
    dashboard: 'Genel Bakış',
    targets: {
      current: 'Güncel Hedefler',
      compare: 'Hedef Karşılaştırma'
    },
    projects: {
      title: 'Projeler',
      list: 'Proje Listesi'
    },
    publications: {
      title: 'Yayınlar',
      list: 'Yayın Listesi',
      departments: 'Birim Yayınları'
    },
    charts: 'Grafikler'
  }
}; 